import { BulkActionEntryData } from "@/common/types/bulkActions/entry.type";
import Button from "../../Button";
import Modal from "../../Modal";

interface BulkActionEntrySuccessModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  entry: BulkActionEntryData;
  onCloseModal: VoidFunction;
  setActionerKlassToOpenNewEntryModal?: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const BulkActionEntrySuccessModal = ({
  isOpen,
  setIsOpen,
  entry,
  onCloseModal,
  setActionerKlassToOpenNewEntryModal,
}: BulkActionEntrySuccessModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="min-w-[860px] min-h-[640px] max-h-[640px] bg-green-950/50 backdrop-blur-[4px] flex flex-col"
      body={(
        <div className="flex flex-col gap-6 items-center pt-24">
          <div>
            <img src="/success.gif" className="h-56" />
          </div>

          <div className="flex flex-col gap-6 items-center">
            <div className="flex flex-col gap-2 items-center">
              <p className="text-lg text-white-800">{entry?.title} finalizado com sucesso!</p>

              <p className="text-white-400">O que você deseja fazer em seguida?</p>
            </div>

            <div className="flex flex-col gap-4 items-center">
              {setActionerKlassToOpenNewEntryModal && (
                <Button
                  className="ms-auto text-white-800"
                  onClick={() => {
                    setActionerKlassToOpenNewEntryModal(entry?.actioner_klass);
                    onCloseModal();
                  }}
                >
                  Realizar outra ação em massa
                </Button>
              )}

              <Button variant="link-white" onClick={() => setIsOpen(false)}>
                Voltar
              </Button>
            </div>
          </div>
        </div>
      )}
    />
  );
};
